import {useState} from "react";
import {Box, Alert, CloseButton} from "@chakra-ui/react";
import {useCalculator} from "../context/calculatorContext/context";

const BucketAlert = () => {
  const {selectedData} = useCalculator();
  const [manuallyClosed, setManuallyClosed] = useState(false);

  const isOpen = selectedData.length > 0 && !manuallyClosed;

  return (
    <Box>
      {isOpen && (
        <Alert.Root status="info">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Description>
              Item&apos;s have been added to your bucket. Click on bucket to check the
              suggested package
            </Alert.Description>
          </Alert.Content>
          <CloseButton
            pos="relative"
            top="-2"
            insetEnd="-2"
            onClick={() => {
              setManuallyClosed(true);
            }}
          />
        </Alert.Root>
      )}
    </Box>
  );
};

export default BucketAlert;
